import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FuseSharedModule } from '@fuse/shared.module';
import { AreaChartModule as NgxAreaChartModule } from '@swimlane/ngx-charts';
import { AreaChartComponent } from './area.component';

@NgModule({
  declarations: [
    AreaChartComponent
  ],
  imports: [
    NgxAreaChartModule,
    FlexLayoutModule,
    FuseSharedModule
  ],
  exports: [
    AreaChartComponent
  ]
})
export class AreaChartModule {}
